module.exports = __webpack_public_path__ + "img/Marianna.a6e52926.jpg";